var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftSliderArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -10,
    y: -10,
    width: 38,
    height: 38
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(5px)",
      clipPath: "url(#bgblur_0_41_6941_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    "data-figma-bg-blur-radius": 10,
    cx: 9,
    cy: 9,
    r: 8.8,
    fill: "black",
    fillOpacity: 0.5,
    stroke: "white",
    strokeWidth: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 12.4995C10.4342 12.4999 10.369 12.4873 10.3081 12.4624C10.2472 12.4375 10.1918 12.4009 10.145 12.3545L7.14503 9.35453C7.0519 9.26084 6.99963 9.13412 6.99963 9.00203C6.99963 8.86993 7.0519 8.74321 7.14503 8.64953L10.145 5.64953C10.2407 5.56761 10.3637 5.52481 10.4896 5.52967C10.6154 5.53453 10.7348 5.5867 10.8238 5.67574C10.9129 5.76479 10.965 5.88416 10.9699 6.01C10.9747 6.13584 10.9319 6.25887 10.85 6.35453L8.20503 8.99953L10.85 11.6445C10.9202 11.7142 10.9682 11.8031 10.9879 11.9C11.0076 11.9969 10.9981 12.0974 10.9607 12.189C10.9232 12.2805 10.8594 12.3588 10.7775 12.4141C10.6955 12.4694 10.5989 12.4991 10.5 12.4995Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_41_6941_clip_path",
    transform: "translate(10 10)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 8.8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftSliderArrow);
export default __webpack_public_path__ + "static/media/leftSliderArrow.a988b02a5a8187ab7b58624da3332bee.svg";
export { ForwardRef as ReactComponent };